import { type Repub } from '@cx-modules/constants';

import FooterNavColumn from './components/FooterNavColumn';
import type { CategoryLink } from './types/CategoryLink.interface';
import styles from './FooterNav.module.css';

export type FooterNavProps = {
  categoryLinks: CategoryLink[];
  repub: Repub;
};

export function FooterNav({ categoryLinks }: FooterNavProps) {
  return (
    <nav className={styles.footerNavContainer} data-testid="footer-nav">
			<div className={styles.footerNavWrapper}>
				<ul className={styles.footerNavColumns}>
					{categoryLinks.
          filter((group) => group.links.length > 0).
          map((props) =>
          <FooterNavColumn key={props.name} {...props} />
          )}
				</ul>
			</div>
		</nav>);

}